import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-profile-information',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile-information.component.html',
  styleUrl: './profile-information.component.scss'
})
export class ProfileInformationComponent {
  @Input() userName!: string;
  @Input() userRole!: string;
  @Input() userEmail!: string;
  @Input() userRegion!: string;
  @Input() userIconClass: string = 'bi bi-person-fill';

}
